const routeMain = () => "/privacy";

export default routeMain;